import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

function NextArrow({ onClick }) {
  return (
    <div className=" absolute right-0 top-[-45px] " onClick={onClick}>
      <div className="bg-white h-[30px] w-[30px] rounded-full text-[#6C757D]  border-2  border-[#6C757D]  grid place-items-center  cursor-pointer duration-150 hover:h-[32px] hover:w-[32px] ">
        <ChevronRightIcon className="h-4 w-4 " />
      </div>
    </div>
  );
}

export default NextArrow;
